import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseResume } from "../_types/case-resume";

@Injectable({
    providedIn: 'root',
})
export class CasesResumesService extends Service<CaseResume> {
    public override type = 'caseResumes';
    public override url = 'attendance/caseResumes';
}
